<div class="pagination-section" *ngIf="count > perPage">  
	<ul class="pagination">	
		<li class="page-item"> 
			<a class="page-link disabled" href="javascript:void(0)" *ngIf="page === 1" aria-label="Previous"> « {{'SHARED.ELEMENT.PAGINATION.PREVIOUS' | translate}} </a>
			<a class="page-link" href="javascript:void(0)" (click)="onPrev()" *ngIf="page != 1" aria-label="Previous"> « {{'SHARED.ELEMENT.PAGINATION.PREVIOUS' | translate}} </a>  
		</li>	
		<li *ngFor="let pageNum of getPages()" class="page-item">
			<a [ngClass]="[(pageNum === page)?'page-link active scroll_top_page':'page-link scroll_top_page']" href="javascript:void(0)" (click)="onPage(pageNum)" *ngIf="pageNum != page">{{ pageNum }}</a>
			<a [ngClass]="[(pageNum === page)?'page-link active scroll_top_page':'page-link scroll_top_page']" href="javascript:void(0)" *ngIf="pageNum === page">{{ pageNum }}</a>
		</li>	
		<li class="page-item"> 
			<a class="page-link disabled" href="javascript:void(0)" *ngIf="lastPage()" aria-label="Next">  {{'SHARED.ELEMENT.PAGINATION.NEXT' | translate}} » </a> 
			<a class="page-link" href="javascript:void(0)" (click)="onNext(true)" *ngIf="!lastPage()" aria-label="Next"> {{'SHARED.ELEMENT.PAGINATION.NEXT' | translate}} » </a>
		</li>	
    </ul>  
</div>